import useSpline from '@splinetool/r3f-spline'
import { useControls } from 'leva'

export default function Blob({ ...props }) {

  const { nodes, materials } = useSpline('https://prod.spline.design/ce49onzKSu6Tl-pG/scene.splinecode')
  // const {blob1, blob2, scale} = useControls('blob', {
  //   blob1:{value:[4.5,-10,-2000]
  //   },
  //   blob2:{value:[4.5,-10,-2000]
  //   },
  //   scale:{value:1, min: 0, max: 10 }
  // })
  
  return (
    <>
      
        <group {...props} dispose={null}>
          <mesh
            name="Blob1 2"
            geometry={nodes['Blob1 2'].geometry}
            material={nodes.Blob1.material}
            castShadow
            receiveShadow
            position={[-326,70,-500]}
            scale={0.2}
            
          />
          <mesh
            name="Blob1"
            geometry={nodes.Blob1.geometry}
            material={nodes.Blob1.material}
            castShadow
            receiveShadow
            position={[-436,-10,-190]}
            scale={0.2}
          />
    
        </group>

    </>
  )
}


